/** @format */

import React from "react";

const NoMatch = () => {
  return <div>ERROR: PAGE NOT FOUND</div>;
};

export default NoMatch;
